import { observer } from 'mobx-react';
import { useContext, useEffect, useMemo, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { storesContext } from '../../../stores/storesContext';
import PageTitle from '../../helpers/PageTitle';
import { errorToast } from '../../helpers/toasts/ToastUtils';
import BlockButtons from '../BlockButtons';
import PageContent from './PageContent';

const AlcmOverviewPage = () => {
  const userStore = useContext(storesContext);
  const propertiesStore = userStore.propertiesStore;
  const alcmStore = userStore.alcmStore;
  const [selectedBlockId, setSelectedBlockId] = useState(null);

  const selectedBlock = useMemo(
    () => alcmStore.monitoringBlocks.find((mb) => mb.id === selectedBlockId),
    [alcmStore.monitoringBlocks, selectedBlockId]
  );

  useEffect(() => {
    if (!userStore.selectedDatabase || !propertiesStore.selectedProperty)
      return;

    alcmStore
      .fetchMonitoringBlocks(propertiesStore.selectedProperty.id, [
        'alcmPackhouseAssessment',
        'alcmSprayData'
      ])
      .catch(() => {
        errorToast('Failed to load blocks.');
      });
  }, [alcmStore, propertiesStore.selectedProperty, userStore.selectedDatabase]);

  return (
    <Container id='page-container' className='mb-4'>
      <Row className='mb-3'>
        <Col>
          <PageTitle title={'ALCM Overview'} />
        </Col>
      </Row>
      {userStore.loading ? (
        <div className='text-center py-4'>
          <Spinner animation='border' variant='primary' />
          <p className='text-muted mt-2'>Loading properties...</p>
        </div>
      ) : (
        <>
          {/* Block Selection */}
          {alcmStore.loading || propertiesStore.loading ? (
            <div className='text-center py-4'>
              <Spinner animation='border' variant='primary' size='sm' />
              <p className='text-muted mt-2 mb-0'>Loading blocks...</p>
            </div>
          ) : (
            <>
              <Row className='mb-4 justify-content-center'>
                <Col md={10} lg={8}>
                  <BlockButtons
                    selectedBlockId={selectedBlockId}
                    onClick={(mb) => setSelectedBlockId(mb.id)}
                    disabled={alcmStore.modelLoading}
                  />
                </Col>
              </Row>
              {alcmStore.monitoringBlocks.length === 0 &&
              propertiesStore.selectedProperty ? (
                <div className='text-center py-4'>
                  <p className='text-muted mb-0'>
                    This property has no monitoring blocks.
                  </p>
                </div>
              ) : null}

              {selectedBlock && <PageContent monitoringBlock={selectedBlock} />}
            </>
          )}
        </>
      )}
    </Container>
  );
};

export default observer(AlcmOverviewPage);

